module.exports = __webpack_public_path__ + "img/compony-weixin.c58f4db2.png";